import { IApiResponse } from "@zeal/morn/src/clients/AbstractApiClient/IApiResponse";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetWorkerAstraUserRequestSchema,
  TGetWorkerAstraUserResponseSchema,
} from "./getWorkerAstraUser.schema";

export const getWorkerAstraUser = (axios: IAxiosInstance) => {
  return async (params: TGetWorkerAstraUserRequestSchema) => {
    const { worker_id } = params;
    const { data } = await axios.noRetry.get<
      IApiResponse<TGetWorkerAstraUserResponseSchema>
    >(`/push-to-card/worker?workerID=${worker_id}`);

    return data.data;
  };
};
